// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"feedback_feedbackContainer__JFNO-","feedbackContent":"feedback_feedbackContent__tl24I","feedbackCard":"feedback_feedbackCard__77909"};